export default __webpack_public_path__ + "maps-examples-offline-pack-thumbnail-480-28e812bb91a38e8a931e3ab310c7512b.png";